import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isGetGameListFinished: false,
        currency: "",
        lang: "en",
        jackpotInfos: [],
        activeJackpotId: "",
        jackpotGames: {},
        cdnUrl: "",
        newCdnUrl: "",
        imgVersion: "",
        playForRealText: "",
        availableSoonText: "",
        isBsi: false,
        routeMapping: {}
    },
    mutations: {
        setJackpotInfos(state, data) {
            state.jackpotInfos = data;
        },
        setActiveJackpotId(state, data) {
            state.activeJackpotId = data;
        },
        setCdnUrl(state, data) {
            state.cdnUrl = data;
        },
        setNewCdnUrl(state, data) {
            state.newCdnUrl = data;
        },
        setImgVersion(state, data) {
            state.imgVersion = data;
        },
        setPlayForRealText(state, data) {
            state.playForRealText = data;
        },
        setAvailableSoonText(state, data) {
            state.availableSoonText = data;
        },
        setJackpotGames(state, data) {
            state.jackpotGames = data;
        },
        setIsGetGameListFinished(state, data) {
            state.isGetGameListFinished = data;
        },
        setIsBsi(state, data) {
            state.isBsi = data;
        },
        setRouteMapping(state, data) {
            state.routeMapping = data;
        },
    },
    actions: {
        getDisplayData({commit, state}, lang) {
            Axios.get(`${this.state.isBsi ? '/games' : ''}/gamelobby/FeatureCategoryDisplayData`, {
                    params:{
                        lang: lang
                    }
                })
                .then((resp) => {
                    commit('setJackpotInfos', Object.keys(resp.data.Games));
                    commit('setActiveJackpotId', Object.keys(resp.data.Games)[0]);
                    let mapping = new Map();
                    for(let key in resp.data.Localization){
                        mapping.set(resp.data.Localization[key], key);
                    }
                    commit('setRouteMapping', mapping);
                    commit('setCdnUrl', resp.data.CdnUrl);
                    commit('setNewCdnUrl', resp.data.NewCdnUrl);
                    commit('setImgVersion', resp.data.ImgVersion);
                    commit('setPlayForRealText', resp.data.PlayForRealText);
                    commit('setAvailableSoonText', resp.data.AvailableSoonText);
                    commit('setJackpotGames', Object.keys(resp.data.Games).map(x => ({"category":x, "games": resp.data.Games[x]})));
                    commit('setIsGetGameListFinished', true);

                    const urlSeg = document.location.href.split('/');
                    const gamesIndex = urlSeg.findIndex(seg => seg === 'games');
                    if(urlSeg.length > gamesIndex + 2) {
                        const subCategoryRouteName = decodeURI(urlSeg[gamesIndex + 2].toLowerCase());
                        if(resp.data.Localization[subCategoryRouteName] && subCategoryRouteName){
                            commit('setActiveJackpotId', resp.data.Localization[subCategoryRouteName]);
                        }
                    }
                });
        },
        setIsBsi({commit}) {
            let host = window.location.hostname;
            let subDomain = host.split(".")[0];
            const isBsi = subDomain === 'www';
            commit('setIsBsi', isBsi)
        },
    },
    getters: {},

});
